import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EventDispatcherService} from '../../events/event-dispatcher.service';
import {FieldAffix} from '../field-affix';

@Component({
    selector: 'mydocma-dynamic-field-affix',
    templateUrl: './dynamic-field-affix.component.html',
    styleUrls: ['./dynamic-field-affix.component.scss']
})
export class DynamicFieldAffixComponent implements OnChanges {
    @Input() readonly: boolean;
    @Input()
    public fieldAffix: FieldAffix;
    public isReadOnly: boolean;


    @Output()
    public clickEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(public eventDispatcher: EventDispatcherService) {
    }

    public onClick() {
        this.clickEvent.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.readonly?.currentValue || changes.fieldAffix?.currentValue) {
            if (this.fieldAffix?.hasOwnProperty('readonly')) {
                this.isReadOnly = !!this.fieldAffix?.readonly;
            } else {
                this.isReadOnly = !!this.readonly;
            }
        }
    }
}
